import React from 'react';
import InfoIcon from '../../images/info.png';
const CompleteOrderTotal =props=>{
  console.log("props.orderTotal",props.orderTotal)
      let {currency_symbol}=props.orderTotal;
      if(props.orderTotal && props.orderTotal.status == "success"){
        return(
          <div className="order_totals_container p-3">
          <div className="row">
            <div className="col-3">Item(s) : <p className="count">{props.orderTotal.job_order.total_item_count}</p></div>
            <div className="col-3">T. Qty: <p className="count">{parseInt(props.orderTotal.job_order.total_qty_ordered)}</p></div>
            <div className="col-6 pl-4 totals_block">
              <span className="order_totals_label">Sub Total:</span> <span className="count">{props.orderTotal.job_order.currency_code}{props.orderTotal.job_order.subtotal}</span><br />
              <span className="order_totals_label">Shiping:</span> <span className="count">{props.orderTotal.job_order.currency_code}{props.orderTotal.job_order.shipping_amount}</span><br />
              <span className="order_totals_label">Discount:</span> <span className="count">-{props.orderTotal.job_order.currency_code}{props.orderTotal.job_order.discount_amount}</span><br />
              <span className="order_totals_label">Promo Cash:</span> <span className="count">-{props.orderTotal.job_order.currency_code}{props.orderTotal.job_order.promo_cash}</span><br />
              
            </div>
          </div>
          <div className="text-right text-danger pb-1 pt-1">{props.orderTotal.job_order.refund_amount || props.orderTotal.job_order.total_refunded
               ?
               <span>Returned products on Rs.{props.orderTotal.job_order.currency_code}{(props.orderTotal.job_order.refund_amount?parseFloat(props.orderTotal.job_order.refund_amount):0)+parseFloat(props.orderTotal.job_order.total_refund)}
                 <span className="info_icon ml-3"><img src={InfoIcon} alt='Info'/></span></span> :''}</div>
          <div className="grand_totals_container pb-2 pt-2 mt-3">
            <div className="row">
              <div className="col-6 text-left">Grand Total :</div>
              <div className="col-6 text-right">{props.orderTotal.job_order.currency_code}{props.orderTotal.job_order.grand_total}</div>
            </div>
          </div>
          </div>
      );
      }
      else{
        return(<div>No data</div>)
      }
   
}
export default CompleteOrderTotal;



// WEBPACK FOOTER //
// ./src/components/Completed/completeOrderTotal.js